@let traductions = referentiel().metadonnees.traductions;
@let familleDeLivrables = traductions.familleDeLivrables.toLowerCase();

<div class="gap-xl grid">
  @if (peutModifier()) {
    <div>
      <button (click)="showFormFamillesLivrables()" hlmBtn>
        Ajouter une {{ familleDeLivrables }}
        <ng-icon name="lucidePlus" />
      </button>
    </div>
  }

  @for (famille of famillesLivrables() | trierPar: 'nom'; track famille.id) {
    <div class="gap-xs grid">
      <app-expansion-panel
        [titre]="famille.nom"
        [actions]="peutModifier() ? familleLivrablesAction : []"
        [item]="famille"
      >
        <div class="grid">
          @for (livrable of famille.livrables | trierPar: 'nom'; track livrable.id; let last = $last) {
            <div
              class="pl-md pr-xs py-xs group/item hover:bg-components-background-neutral-lighter flex h-[48px] items-center justify-between hover:rounded-b-md"
            >
              <span class="pl-xs component-medium-medium">
                {{ livrable.nom }}
              </span>
              @if (peutModifier()) {
                <button
                  class="invisible group-hover/item:visible"
                  [hlmDropdownMenuTrigger]="actionsLivrableMenu"
                  [hlmDropdownMenuTriggerData]="{ $implicit: { item: livrable } }"
                  (click)="$event.stopPropagation()"
                  hlmBtn
                  variant="ghost"
                  size="icon"
                >
                  <ng-icon name="lucideEllipsisVertical" />
                </button>
              }
            </div>

            @if (!last) {
              <div hlmItemSeparator></div>
            }
          } @empty {
            <div class="pl-md pr-xs py-xs">
              <span class="paragraph-medium-medium text-content-secondary"
                >Aucun {{ traductions.livrable }} lié à cette {{ familleDeLivrables }}.</span
              >
            </div>
          }
        </div>
      </app-expansion-panel>
      @if (peutModifier()) {
        <app-button-add-new [label]="'Ajouter un nouveau ' + traductions.livrable" (click)="ajouterLivrable(famille)" />
      }
    </div>
  } @empty {
    <app-empty-state [title]="'Aucune ' + familleDeLivrables + ' créée'">
      <span class="text-content-secondary text-center"
        >Pour créer une {{ familleDeLivrables }}, cliquez sur le bouton « Ajouter une {{ familleDeLivrables }} ».</span
      >
    </app-empty-state>
  }
</div>

<ng-template #actionsLivrableMenu let-ctx>
  <hlm-dropdown-menu>
    @for (action of livrablesAction; track $index) {
      <button (triggered)="action.action(ctx.item)" hlmDropdownMenuItem>
        <ng-icon [name]="action.icon" hlmMenuIcon />
        {{ action.label }}
        @if (action.shortcut) {
          <hlm-dropdown-menu-shortcut>{{ action.shortcut }}</hlm-dropdown-menu-shortcut>
        }
      </button>
    }
  </hlm-dropdown-menu>
</ng-template>
